import chartConfiguration from './chart-configuration'
import tableView from './table-view'

export default {
    title: 'Analysis',

    panel: 'Panel filter',

    empty: 'There are no ratings available yet.',

    chartConfiguration,
    tableView
}
